import { version } from '@hb/shared'
import { initializeApp } from 'firebase/app'
// import { getInstallations, getToken } from 'firebase/installations'
import { siteVersions } from './firebaseConfig'

export const app = initializeApp(siteVersions[version].firebaseConfig)
// getToken(getInstallations(app), true)

// Secondary app instance used exclusively for GYN intake sessions.
// Isolated from the main app's auth state so signInWithCustomToken doesn't
// trigger global onAuthStateChanged handlers or routing side effects.
export const gynIntakeApp = initializeApp(siteVersions[version].firebaseConfig, 'gyn-intake')
// Storage bound to gynIntakeApp so requests are authenticated with the gynIntakeSession token.
